import { Injectable } from '@angular/core';
import { ConfirmModalComponent } from '@ui/confirm-modal/confirm-modal.component';
import { ModalService } from '@ui/modal/modal.service';

export interface ConfirmOptions {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'danger' | 'success' | 'warning';
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  constructor(private modalService: ModalService) {}

  confirm(options: ConfirmOptions = {}): Promise<boolean> {
    return new Promise((resolve) => {
      const modalRef = this.modalService.open(ConfirmModalComponent, {
        data: {
          title: options.title || 'Weet u het zeker?',
          message: options.message || 'Wilt u doorgaan met deze actie?',
          confirmText: options.confirmText || 'Ja',
          cancelText: options.cancelText || 'Nee',
          variant: options.variant || 'danger',
          onConfirm: () => {
            resolve(true);
            this.modalService.close(modalRef);
          },
          onClose: () => {
            resolve(false);
            this.modalService.close(modalRef);
          }
        }
      });
    });
  }
}
